import React from "react";
import { Outlet, useParams } from "react-router-dom";

import { Header } from "../../components/Header";
import { SideBar } from "../../components/Sidebar";

export const MainLayout = ({ children, role }) => {
  const { groupId, groupName } = useParams();
  return (
    <div className="container">
      <SideBar userRole={role} />
      <div className="content-container">
        <Header userRole={role} />
        <main className={groupId && groupName ? "iFrame-content" : "content"}>
          {children}
          <Outlet />
        </main>
      </div>
    </div>
  );
};
